import React from 'react';
import MinigameCenter from '../../components/Minigame/MinigameCenter';
import SportsRight from '../../components/sports/SportsRight';

const Nuguri = () => {
    return (
        <div data-v-623d66c4="" className="contents row" style={{flexDirection: "row"}}>
            <MinigameCenter type="nuguri"/>
            <SportsRight type="minigame"/>
        </div>
    );
};

export default Nuguri;


// WEBPACK FOOTER //
// ./src/containers/minigame/Nuguri.js